import { render, staticRenderFns } from "./autorizacion_CI.vue?vue&type=template&id=3779f425"
import script from "./autorizacion_CI.vue?vue&type=script&lang=js"
export * from "./autorizacion_CI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports